module.exports = __webpack_public_path__ + "img/recycle-blue.e5baebb8.png";